import React from 'react'
import PropTypes from 'prop-types'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { Grid, Paper } from '@material-ui/core'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableSortLabel from '@material-ui/core/TableSortLabel'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableFooter from '@material-ui/core/TableRow'
import TablePagination from '@material-ui/core/TablePagination'
import CircularProgress from '@material-ui/core/CircularProgress'
import moment from 'moment'

//import { TableFormats } from './TableHelpers'

import { TRACKER_TEASERS_TRAILERS } from '../../constants/module_info'
import { withStyles } from '@material-ui/core/styles'
import { styles } from '../../classes/Styles'
import DateHelpers from '../../classes/DateHelpers'
import Thumbnail from '../widgets/Thumbnail'

export class TrackerTeasersTrailersComponent extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    screenWidth: PropTypes.number,
    trackerPlan: PropTypes.object,
    teasersAndTrailers: PropTypes.object,
    selectedTrackerEntityName: PropTypes.string
  }


  constructor (props) {
    super(props)

    this.state = {
      page: 0
    }
  }

  componentDidUpdate (prevProps) {
    if (prevProps.selectedTrackerEntityName !== this.props.selectedTrackerEntityName) {
      this.setState({ page: 0 })
    }
  }

  render () {
    const { classes, screenWidth, teasersAndTrailers } = this. props
    //const name = trackerPlan.details && trackerPlan.details.tracker_topic ? trackerPlan.details.tracker_topic.tracker_name : ''

    const handleChangePage = page => {
      this.setState({ page: page})
    }

    return (
      <Paper className={classes.paper}>
        <Grid container spacing={1} direction="column">
          <Grid item className='cardPadding'>
            <span className={classes.cardTitle}>Teasers and Trailers</span>
            <OverlayTrigger overlay={<Tooltip id="tooltip">{TRACKER_TEASERS_TRAILERS}</Tooltip>} placement="right">
              <img className={classes.cardInfo} src="/static/images/info.png" alt="info"/>
            </OverlayTrigger>
          </Grid>
          <Grid item className={classes.cardSubTitle}>Promotional videos affiliated with {this.props.selectedTrackerEntityName}</Grid>
        </Grid>
        { (teasersAndTrailers && teasersAndTrailers.isFetching) &&
          <div className='loadingProgress'>
            <CircularProgress />
          </div>
        }
        { (teasersAndTrailers && teasersAndTrailers.details) &&
          <Grid container spacing={1}>
            <TeasersAndTrailers
              classes={classes}
              screenWidth={screenWidth}
              teasersAndTrailers={teasersAndTrailers}
              page={this.state.page}
              handleChangePage={handleChangePage}
              />
          </Grid>
        }
      </Paper>
    )
  }
}

export class TeasersAndTrailers extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    screenWidth: PropTypes.number,
    teasersAndTrailers: PropTypes.object,
    page: PropTypes.number.isRequired,
    handleChangePage: PropTypes.func.isRequired
  }

  constructor (props) {
    super(props)

    this.state = {
      rowsPerPage: this.props.screenWidth < 1023.98 ? 2 : 4
    }
  }

  componentDidUpdate (prevProps) {
    if (prevProps.screenWidth !== this.props.screenWidth) {
      this.setState({ rowsPerPage: this.props.screenWidth < 1023.98 ? 2 : 4 })
    }
  }

  render () {
    const { classes, screenWidth, teasersAndTrailers } = this.props
    let teasersAndTrailerList = teasersAndTrailers.details && teasersAndTrailers.details.teasers_and_trailers
      ? teasersAndTrailers.details.teasers_and_trailers : []
    const rows = []
    const noData = teasersAndTrailerList && teasersAndTrailerList.length > 0 ? false : true
    const charLength = screenWidth < 395 ? 20 : screenWidth >= 375 && screenWidth < 479.95 ? 40
    : screenWidth >= 480 && screenWidth < 767.98 ? 80
    : screenWidth >= 768 && screenWidth < 1023.98 ? 120
    : screenWidth >= 1024 && screenWidth < 1049.98 ? 40
    : screenWidth >= 1050 &&screenWidth < 1229.98 ? 50
    : screenWidth >= 1230 && screenWidth < 1439.98 ? 100
    : (screenWidth >= 1440)
    ? 150 : 150

    const createData = (platformAssignedId, thumbnail, title, channel, date ) => {
      return { platformAssignedId, thumbnail, title, channel, date }
    }

    if (!noData) {
      teasersAndTrailerList.map(t => rows.push(createData(t.platform_assigned_id, t.thumbnail, t.video_title, t.channel_name, t.published_at)))
      rows.sort((a, b) => new Date(b.date) - new Date(a.date))
    } else {
      rows.push(createData(null, null, null, null, null))
      rows.push(createData(null, null, null, null, null))
      rows.push(createData(null, null, null, null, null))
      rows.push(createData(null, null, null, null, null))
    }
    const titleWithTooltip = (title) => {
      if (title && title.length > charLength) {
        const tooltip = <Tooltip id="tooltip">{title}</Tooltip>
        return (
          <OverlayTrigger overlay={tooltip} placement='top'>
            <span className="txt">{title.substring(0, charLength)}...</span>
          </OverlayTrigger>
        )
      }
      return (<span>{title}</span>)
    }

    const StyledTableCell = withStyles(() => ({
      head: {
        background: '#F4F5F6'
      }
    }))(TableCell)
    const StyledNoDataCell = withStyles(() => ({
      body: {
        height: screenWidth > 1300 ? '180px' : screenWidth < 520 ? '70px': '100px'
      }
    }))(TableCell)
    return (
      <div className='commonTable teaserTable'>
        <Paper className={classes.root}>
          <TableContainer className={`${classes.teaserContainer} teaserContainer`}>
            <Table stickyHeader>
              <TableHead className={classes.head}>
                <TableRow>
                  <StyledTableCell></StyledTableCell>
                  <StyledTableCell>Title</StyledTableCell>
                  <StyledTableCell>Channel</StyledTableCell>
                  {/* <StyledTableCell>Views</StyledTableCell> */}
                  <StyledTableCell align="right">
                    <TableSortLabel
                      active={true}
                      direction='asc'
                    >
                      Release Date
                    </TableSortLabel>
                  </StyledTableCell>
                </TableRow>
              </TableHead>
              { !noData &&
                <TableBody>
                  {rows.slice(this.props.page * this.state.rowsPerPage, this.props.page * this.state.rowsPerPage + this.state.rowsPerPage)
                  .map((row, index) => (
                    <TableRow key={index}>
                      <TableCell>
                        <Thumbnail
                          entityOverrideImage={row.entity_override_image}
                          thumbnail={row.thumbnail}
                          name={row.title}
                          imageClass={classes.trendingVideosImage}
                          noImgTextClass={'trackerNoImgText'}
                          noImgClass={'trackerVideoNoImg'}
                          divId={`tracker_video_${index}`}
                        />
                      </TableCell>
                      <TableCell>
                        { noData &&
                          <span className='noData'>
                            --
                          </span>
                        }
                        { !noData &&
                          <a href={'https://www.youtube.com/watch?v=' + row.platformAssignedId} target="_blank" rel="noopener noreferrer" className={classes.cursorPointer}>
                            {titleWithTooltip(row.title)}
                          </a>
                        }
                      </TableCell>
                      <TableCell>{row.channel ? row.channel : '--'}</TableCell>
                      {/* <TableCell>{TableFormats.formatKM(row.views).toLowerCase()}</TableCell> */}
                      <TableCell className={noData ? 'noData' : ''}>{row.date ? this.formatDate(row.date) : '--'}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              }
              { noData &&
                <TableBody>
                  <TableRow>
                    <StyledNoDataCell colSpan={4} align="center" style={{ textAlign: 'center' }}>
                      <span className={classes.teaserNoDataText}>Related videos will appear here once posted to YouTube</span>
                    </StyledNoDataCell>
                  </TableRow>
                </TableBody>
              }
            </Table>
          </TableContainer>
          { !noData &&
            <Table className='tableFooter'>
              <TableBody>
                <TableFooter>
                  <TablePagination
                    rowsPerPageOptions= {this.state.rowsPerPage === 4 ? [4, 8, rows.length] : [2, 4, rows.length]}
                    count={rows.length}
                    rowsPerPage={this.state.rowsPerPage}
                    page={this.props.page}
                    onChangePage={this.handleChangePage}
                  />
                </TableFooter>
              </TableBody>
            </Table>
          }
        </Paper>
      </div>
    )
  }

  formatDate = (date) => {
    const premiereDate = moment(new Date(date))
    if (DateHelpers.isYearEndDate(premiereDate)) {
      return premiereDate.format('YYYY')
    }
    return premiereDate.format('MM.DD.YY')
  }

  handleChangePage = (event, newPage) => {
    this.props.handleChangePage(newPage)
  }
}

export default withStyles(styles)(TrackerTeasersTrailersComponent)